import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";

const RenderLoading = () => {
  return (
    <div className="w-full flex flex-col h-2/3 pb-3">
      <div className="flex justify-between items-center py-3 flex-col">
        {/* Top Bar Skeleton*/}
        <div className="flex w-full justify-between items-center mb-4">
          <Skeleton variant="rectangular" width="30%" height={40} />
          <Skeleton variant="rectangular" width="15%" height={40} />
        </div>

        {/* Table Skeleton */}
        <TableContainer component={Paper} className="shadow-lg rounded-lg">
          <Table>
            <TableHead className="bg-gray-200">
              <TableRow>
                <TableCell>
                  <Skeleton width="30%" />
                </TableCell>
                <TableCell>
                  <Skeleton width="40%" />
                </TableCell>
                <TableCell>
                  <Skeleton width="60%" />
                </TableCell>
                <TableCell>
                  <Skeleton width="70%" />
                </TableCell>
                <TableCell>
                  <Skeleton width="90%" />
                </TableCell>
                <TableCell>
                  <Skeleton width="90%" />
                </TableCell>
                <TableCell>
                  <Skeleton width="40%" />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from({ length: 8 }).map((_, index) => (
                <TableRow
                  key={index}
                  className="hover:bg-gray-100"
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>
                    <Skeleton width="30%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="40%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="60%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="70%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="90%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="90%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="40%" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default RenderLoading;
